import { useCallback, useMemo } from 'react';

import { useAuthentication } from '@givebacks/api';
import {
  ConsumerList,
  useConsumerSubscribeToList,
  useConsumerUnsubscribeToList,
} from '@givebacks/api/backer';
import { getErrorMessage_v2 } from 'core/Utils';
import { Switch, notifications } from 'ui';

const ListSubscriptionSwitch = ({
  list,
  causeId,
  token,
}: {
  list: ConsumerList;
  causeId?: string;
  token?: string;
}) => {
  const { mutate: subscribeToList, isPending: isSubscribing } = useConsumerSubscribeToList();
  const { mutate: unsubscribeToList, isPending: isUnsubscribing } = useConsumerUnsubscribeToList();

  const { isAuthenticated } = useAuthentication();

  const onToggle = useCallback(
    (subscribe: boolean) => {
      if (subscribe) {
        subscribeToList(
          { causeId, listId: list.uuid, token },
          {
            onError: (error) => {
              notifications.show({
                variant: 'error',
                message: getErrorMessage_v2(error),
              });
            },
          }
        );
      } else {
        unsubscribeToList(
          { causeId, listId: list.uuid, token },
          {
            onError: (error) => {
              notifications.show({
                variant: 'error',
                message: getErrorMessage_v2(error),
              });
            },
          }
        );
      }
    },
    [causeId, list.uuid, token, subscribeToList, unsubscribeToList]
  );

  const isDisabledWithoutAuth = useMemo(() => {
    return !isAuthenticated && list.status != 'subscribed' && list.status != 'requested';
  }, [isAuthenticated, list.status]);

  return (
    <Switch
      disabled={isSubscribing || isUnsubscribing || isDisabledWithoutAuth}
      checked={list.status == 'subscribed' || list.status == 'requested'}
      onChange={(event) => onToggle(event.target.checked)}
      size="lg"
    />
  );
};

export { ListSubscriptionSwitch };
